export const partition = <T>(array: T[], predicate: (item: T, index: number) => boolean): [T[], T[]] => {
  const truthy: T[] = []
  const falsy: T[] = []

  array.forEach((item, index) => {
    if (predicate(item, index)) {
      truthy.push(item)
    } else {
      falsy.push(item)
    }
  })

  return [truthy, falsy]
}
